module.exports = __webpack_public_path__ + "static/media/maintenance_page_mobile.360d6046.png";